import { ApiClient } from './client';
import type { EnglishLevel } from '@/types/story.types';

export type PreferencesAnalyticsRange = 'week' | 'month' | 'all';

export interface PreferencesAnalyticsItem {
  categoryId: string;
  name: string;
  nameTranslation: string | null;
  slug: string;
  icon: string | null;
  users: number;
  /** % usuarios que la pidieron, redondeado a 1 decimal (0–100). */
  percentage: number;
  perLevel: Record<EnglishLevel, number>;
  /** Stories published que tienen esta categoría. Insumo para gap analysis. */
  storiesAvailable: number;
}

export interface PreferencesAnalyticsResponse {
  range: PreferencesAnalyticsRange;
  totalUsers: number;
  items: PreferencesAnalyticsItem[];
}

export const analyticsPreferencesAPI = {
  get: async (params: {
    range: PreferencesAnalyticsRange;
    level?: EnglishLevel;
    companyId?: string;
  }): Promise<PreferencesAnalyticsResponse> => {
    const q = new URLSearchParams();
    q.set('range', params.range);
    if (params.level) q.set('level', params.level);
    if (params.companyId) q.set('companyId', params.companyId);
    return ApiClient.get<PreferencesAnalyticsResponse>(
      `/backoffice/analytics/preferences?${q.toString()}`,
    );
  },
};
